import 'bootstrap-icons/font/bootstrap-icons.min.css';
import React, { use } from 'react';

import { styles } from './icon.styles';

/**
 * Props para el componente Icon.
 */
type IconProps = {
  /**
   * El nombre de la clase del ícono de Bootstrap (p. Ej., 'bi-check-circle').
   */
  className?: string;
  /**
   * Estilos personalizados opcionales que se aplicarán al ícono.
   */
  style?: React.CSSProperties;
  /**
   * Si es verdadero, se mostrará un spinner de carga en lugar de un ícono.
   *
   * @default false
   */
  loading?: boolean;
};

const keyframes = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

/**
 * Un componente para mostrar íconos de Bootstrap o un spinner de carga.
 *
 * @param {IconProps} props - Las props para el componente Icon.
 *
 * @returns {JSX.Element} El ícono renderizado o el spinner de carga.
 */
export const Icon = ({ className, style, loading }: IconProps) => {
  if (loading) {
    return (
      <>
        <style>{keyframes}</style>
        <div style={{ ...styles.spinner, ...styles.icon }} />
      </>
    );
  }

  return <i className={`bi ${className}`} style={{ ...styles.icon, ...style }} />;
};

export default Icon;
